export interface RoleRequest {
    id?: string;
    name: string;
    permissions: string[],
    tenantId?: string; 
};